import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";

import aiStar from "./ai-star.svg";

export function AIStarSvg({ width = 300, height = 230 }) {
  return (
    <EmbedSvg imgKey="aiStarSvg" src={aiStar} width={width} height={height} />
  );
}
